import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Home from './pages/Home';
import CategoryPage from './pages/CategoryPage';
import Admin from './pages/Admin';
import Contatos from './pages/Contatos';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/categoria/:slug" element={<CategoryPage />} />
          <Route path="/administradora" element={<Admin />} />
          <Route path="/contatos" element={<Contatos />} />
        </Routes>
        <Toaster position="top-center" />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;